// CU-86d45b372 — the basic-info sections shared by /profile and /customer/profile, so the two cannot drift.
import React from "react";
import { Row } from "antd";
import { SectionCard } from "../../../components/shared";
import { User } from "../../../types/admin/UserTypes";
import UserProfileHeader from "./UserProfileHeader";
import UserProfileDetails from "./UserProfileDetails";
import UserProfileTimezone from "./UserProfileTimezone";
import UserProfileAddress from "./UserProfileAddress";

interface SelfProfileBasicInfoSectionsProps {
	user: User;
	isEditing: boolean;
	setUserData: React.Dispatch<React.SetStateAction<User>>;
}

// The three field groups emit bare <Col>s so they share one grid here rather than each owning a card.
const SelfProfileBasicInfoSections: React.FC<SelfProfileBasicInfoSectionsProps> = ({ user, isEditing, setUserData }) => (
	<>
		<SectionCard noPadding>
			<UserProfileHeader user={user} isEditing={isEditing} setUserData={setUserData} />
		</SectionCard>

		<SectionCard title="Personal Information">
			<Row gutter={[16, 12]}>
				<UserProfileDetails user={user} isEditing={isEditing} setUserData={setUserData} />
				<UserProfileTimezone user={user} isEditing={isEditing} setUserData={setUserData} />
				<UserProfileAddress user={user} isEditing={isEditing} setUserData={setUserData} />
			</Row>
		</SectionCard>
	</>
);

export default SelfProfileBasicInfoSections;
